import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { buildQuery } from '../../utils/buildQuery';
import { callApi } from '../../utils/callApi';
import { GetActions, TypeGetActionsR } from './actions';
import ActionTypes, { TActionsState } from './types';
import axios, {CancelTokenSource} from "axios";

let currentCancelSource: CancelTokenSource | null = null;

function* getActionsWorker(action: ReturnType<typeof GetActions.request>): Generator {
  const { data, callBack } = action.payload as TypeGetActionsR;
  let success = true;
  const query = buildQuery(data);

  if (currentCancelSource) {
    currentCancelSource.cancel('Запит скасовано через новий запит');
  }

  const cancelSource = axios.CancelToken.source();
  currentCancelSource = cancelSource;

  try {
    const resp = (yield call(callApi, {
      method: 'get',
      path: query ? `/actions?${query}` : '/actions',
      cancelSource: cancelSource,
    })) as TActionsState['data'];
    
    yield put(GetActions.success(resp));
  } catch (e) {
    success = false;
    
    if (axios.isCancel(e)) {
      console.log('Запит скасовано:', e.message);
    } else {
      const errorMessage = e instanceof Error ? e.message : String(e);
      yield put(GetActions.error(errorMessage));
    }
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* watchFetchRequest() {
  yield takeEvery(ActionTypes.GET_ACTIONS_R, getActionsWorker);
}

export default function* actionsSaga() {
  yield all([fork(watchFetchRequest)]);
}
